"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,15.1c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8S12.9,15.1,12.5,15.1z M12.5,14.1 c-0.1,0-0.2,0.1-0.2,0.2c0,0.2,0.4,0.2,0.4,0C12.7,14.2,12.6,14.1,12.5,14.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,16.9c-0.3,0-0.5-0.2-0.5-0.5v-1.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.8C13,16.7,12.8,16.9,12.5,16.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M17.6,19.9H7.4c-0.3,0-0.5-0.2-0.5-0.5V11c0-0.3,0.2-0.5,0.5-0.5h10.2c0.3,0,0.5,0.2,0.5,0.5v8.4 C18.1,19.6,17.9,19.9,17.6,19.9z M7.9,18.9h9.2v-7.4H7.9V18.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M15.8,11.5H9.2c-0.3,0-0.5-0.2-0.5-0.5V8.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8V11C16.3,11.3,16.1,11.5,15.8,11.5z M9.7,10.5h5.6V8.9c0-1.5-1.2-2.8-2.8-2.8S9.7,7.4,9.7,8.9V10.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.1,21.9c-0.1,0-0.3,0-0.4-0.1L3.3,5.5C3.1,5.3,3.1,5,3.3,4.8c0.2-0.2,0.5-0.2,0.7,0l16.4,16.3c0.2,0.2,0.2,0.5,0,0.7 C20.3,21.9,20.2,21.9,20.1,21.9z"
  }));
};

exports["default"] = _default;